import { Box, Button } from "@bca/ui-library";
import React from "react";
import { Devices } from "../Hooks/useViewport.hook";

const CTAs = ({ onClose, viewportWidth }) => {
  if (viewportWidth === Devices.DESKTOP) return null;
  return (
    <Box
      justifyContent="flex-end"
      width="100%"
      display="flex"
      flexDirection={{
        mobile: "column-reverse",
        desktop: "row",
      }}
      marginTop="40px"
    >
      <Button
        fontSize="body-small"
        marginRight={{
          mobile: "0px",
          desktop: "16px",
        }}
        width={{
          mobile: "100%",
          desktop: "210px",
        }}
        variant="secondary"
        height="42px"
        onClick={onClose}
        data-en="click"
        data-ec="button"
        data-el="back-to-purchases"
        data-ea="navigate"
        data-es=""
      >
        Close
      </Button>
    </Box>
  );
};

export default CTAs;
